/*
 * Jira Ticket:
 * Created Date: Wed, 11th Mar 2020, 16:54:04 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React from 'react';
import {
  Filter,
  ReferenceInput,
  SelectInput,
  TextInput,
  useTranslate,
} from 'react-admin';
import { booleanOptions, userStatus } from 'utils/choices';

const UserFilter = ({
  organisationFilter,
  isAdmin,
  organisationId,
  ...props
}) => {
  const translate = useTranslate();

  return (
    <Filter {...props}>
      <TextInput
        source="email"
        label={'resources.User.fields.email'}
        options={{ resettable: true }}
      />
      <TextInput
        source="id"
        label={'resources.User.fields.id'}
        options={{ resettable: true }}
      />
      <ReferenceInput
        label={'resources.User.fields.project'}
        source="projectId"
        reference="Project"
        perPage={1000}
        filter={{ principalOrganisationId: organisationId }}
        sort={{ field: 'name', order: 'ASC' }}
      >
        <SelectInput
          source="id"
          optionText="name"
          disabled={organisationId ? false : true}
        />
      </ReferenceInput>
      <ReferenceInput
        label="resources.User.fields.organisation"
        source="organisationId"
        reference="Organisation"
        emptyText={translate('resources.User.noOrganisations')}
        perPage={1000}
        sort={{ field: 'name', order: 'ASC' }}
        onChange={organisationFilter}
        alwaysOn
      >
        <SelectInput
          source="id"
          optionText="name"
          options={{
            InputLabelProps: { shrink: true },
            SelectProps: { displayEmpty: true },
          }}
        />
      </ReferenceInput>
      <SelectInput
        label={translate('resources.User.fields.UserStatus')}
        source="status"
        choices={userStatus}
        disabled={false}
      />
      {isAdmin && (
        <SelectInput
          source="isAdmin"
          choices={booleanOptions}
          label={'resources.User.fields.status'}
        />
      )}
    </Filter>
  );
};

export default UserFilter;
